/** Site-wide dark / neon UI + legacy keys used in About resume layout */
export const themeTokens = {
  // Dark shell (hero & global)
  darkBg: "#000000",
  darkBgElevated: "#06060c",
  darkPaper: "rgba(18, 18, 26, 0.92)",
  neon: "#2dd4bf",
  neonBright: "#5eead4",
  neonDim: "rgba(45, 212, 191, 0.35)",
  textOnDark: "#f8fafc",
  mutedOnDark: "#94a3b8",
  borderOnDark: "rgba(148, 163, 184, 0.2)",
  heroGradient:
    "linear-gradient(90deg, #fcd34d 0%, #fb923c 22%, #22d3ee 65%, #06b6d4 100%)",

  // Resume / About (dark variant — cyan on slate)
  navy: "#e2e8f0",
  cyan: "#2dd4bf",
  cyanSoft: "rgba(45, 212, 191, 0.55)",
  cyanPale: "#134e4a",
  cyanDark: "#0d9488",
  bg: "#030308",
  bgAlt: "#0c0c14",
  paper: "rgba(255, 255, 255, 0.06)",
  border: "rgba(148, 163, 184, 0.18)",
  borderStrong: "rgba(45, 212, 191, 0.35)",
  navyMuted: "rgba(226, 232, 240, 0.72)",
  gradient: "linear-gradient(90deg, #2dd4bf, #e2e8f0)",
  gradientVibrant: "linear-gradient(90deg, #14b8a6 0%, #2dd4bf 50%, #22d3ee 100%)",
};
